import { useFormik } from 'formik';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Input } from 'reactstrap';
import { createMessageReply } from 'redux/actions/data/messageActions';
import MessageUtil from 'utils/MessageUtil';

import style from '../../styles/layout.module.css';

const ReplyArea = ({ id }) => {
  const dispatch = useDispatch();
  const { loading: replyLoading, success: replySuccess } = useSelector(
    state => state.createMessageReply,
  );
  const fileInputRef = useRef(null);
  const { values, setFieldValue, handleSubmit, handleChange, handleReset } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        context: '',
        messageId: id,
        reply_files: [],
      },
      onSubmit: () => {
        // Validate that context is not empty and not just whitespace
        if (!values.context || !values.context.trim()) {
          MessageUtil.alertWanring('請輸入回覆內容');
          return;
        }

        const formData = new FormData();

        formData.append('messageId', values.messageId);
        formData.append('context', values.context);
        // If reply_files are File objects, append them individually so backend can receive files.
        if (values.reply_files && values.reply_files.length > 0) {
          if (values.reply_files[0] instanceof File) {
            values.reply_files.forEach(file => {
              formData.append('reply_files', file);
            });
          } else {
            formData.append('reply_files', JSON.stringify(values.reply_files));
          }
        } else {
          formData.append('reply_files', JSON.stringify([]));
        }

        dispatch(createMessageReply(formData));
      },
    });

  useEffect(() => {
    if (replySuccess) {
      handleReset();
    }
  }, [replySuccess]);

  const handleFileChange = e => {
    const files = Array.from(e.target.files || []);
    setFieldValue('reply_files', files);
  };

  return (
    <Card className={style.search_card}>
      <div className={style.card_header}>後台回覆</div>
      <div className={style.card_body}>
        <Input
          type="textarea"
          className="mb-3"
          style={{ height: '230px' }}
          value={values.context}
          id="context"
          onChange={handleChange}
        />
        <input
          type="file"
          accept="image/*"
          multiple
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
          <Button
            className={`${style.modal_button_submit} ${style.modal_button_upload}`}
            onClick={() => fileInputRef.current && fileInputRef.current.click()}
            disabled={replyLoading}
          >
            📷 上傳圖片{values.reply_files && values.reply_files.length > 0 ? ` (${values.reply_files.length})` : ''}
          </Button>
          <span style={{ padding: '0 0.25rem' }}>{'　'}</span>
          <Button
            className={style.modal_button_submit}
            onClick={handleSubmit}
            disabled={replyLoading}
          >
            送出回覆
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default ReplyArea;
